import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['panel', 'bar', 'status', 'submit', 'percent']
  static values = {
    status: { type: String, default: 'Preparing import...' }
  }

  connect () {
    this.progress = 8
    this.timer = null
  }

  disconnect () {
    this.stopTimer()
  }

  start () {
    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = true
      this.submitTarget.classList.add('cursor-wait', 'opacity-80')
    }

    if (this.hasPanelTarget) {
      this.panelTarget.classList.remove('hidden')
    }
    if (this.hasStatusTarget) {
      this.statusTarget.textContent = this.statusValue
    }

    this.setProgress(12)
    this.stopTimer()
    this.timer = window.setInterval(() => {
      const step = this.progress < 55 ? 7 : 3
      this.setProgress(Math.min(this.progress + step, 92))
    }, 650)
  }

  setProgress (value) {
    this.progress = value
    if (this.hasBarTarget) {
      this.barTarget.style.width = `${value}%`
    }
    if (this.hasPercentTarget) {
      this.percentTarget.textContent = `${Math.round(value)}%`
    }
  }

  stopTimer () {
    if (this.timer) {
      window.clearInterval(this.timer)
      this.timer = null
    }
  }
}
